module.exports = __webpack_public_path__ + "img/ma.f90e3f47.svg";